import { Link } from 'react-router-dom';
import { UserIcon } from '@heroicons/react/24/outline';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';
import { SITE_NAME } from '../config/site';

/**
 * Header for logged-out visitors.
 */
function UnauthenticatedHeader() {
  return (
    <header className="fixed left-0 right-0 top-0 h-20 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between px-4 z-40">
      <Link to="/" className="flex items-center gap-2">
        <Logo className="w-8 h-8" />
        <span className="hidden sm:inline text-xl font-semibold text-gray-900 dark:text-white">
          {SITE_NAME}
        </span>
      </Link>

      <nav className="hidden sm:flex items-center gap-6">
        <Link
          to="/leaderboard"
          className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-primary transition-colors"
        >
          Leaderboard
        </Link>
      </nav>

      <div className="flex items-center gap-2 sm:gap-3">
        <ThemeToggle />
        <Link
          to="/login"
          className="flex items-center gap-2 px-3 sm:px-4 py-2 text-sm font-medium text-primary dark:text-primary-light hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
        >
          <UserIcon className="w-5 h-5" />
          <span className="hidden sm:inline">Login</span>
        </Link>
        <Link
          to="/register"
          className="px-3 sm:px-4 py-2 text-sm font-medium text-navy bg-primary hover:bg-primary-dark rounded-md transition-colors"
        >
          Sign Up
        </Link>
      </div>
    </header>
  );
}

export default UnauthenticatedHeader;
